import { BaseGQLService } from '../../../../common/services/BaseGQLService';
import { ModelType } from '../../../../common/utils/GQLIdEncoder';
import { InstanceExportOptions } from '../../../options/InstanceExportOptions';
import { InstanceCsvMapper } from '../mappers/InstanceCsvMapper';
import { InstanceSummary } from '../models/InstanceCsvData';

export const GET_INSTANCE_SUMMARY_QUERY = `
query ($reportId: ID!, $ruleNumber: String, $instanceId: ID!, $includeFilteredRules: Boolean!) {
  report: node(id: $reportId) {
    ... on ReportDone {
      rules(includeFilteredRules: $includeFilteredRules, filters: {field: number, operation: EQ, value: $ruleNumber}) {
        edges {
          node {
            id
            number
            title
            severity
            shortExplanation
            explanation
            consequences
            access
            expertise
            resources
          }
        }
      }
    }
  }
  instance: node(id: $instanceId) {
    ... on Instance {
      id
      numberLocal
      severity
      data
      filterStatus
      remediation {
        general {
          remediation
          triage
          specificRemediationAdvice
        }
      }
      calls {
        edges {
          node {
            id
            timestamp
            arguments
            isKeptByFilters
          }
        }
      }
      operations {
        edges {
          node {
            id
            type
            category
            context
            algorithms
          }
        }
      }
      locations {
        edges {
          node {
            id
            path
            hostname
            fileType
          }
        }
      }
      hardCodedStringLocations {
        class
        method
        line
        file
      }
    }
  }
}
`;

export class InstanceCsvRepository extends BaseGQLService {
  private readonly mapper = new InstanceCsvMapper();

  protected addTypename(): boolean {
    return false;
  }

  async getInstance(options: InstanceExportOptions): Promise<InstanceSummary> {
    const { instanceId, reportId, issueNumber, includeFilteredItems } = options;
    return this.query(
      GET_INSTANCE_SUMMARY_QUERY,
      {
        instanceId: this.gqlIdEncoder.encode(ModelType.Instance, instanceId),
        reportId: this.gqlIdEncoder.encode(ModelType.Report, reportId),
        ruleNumber: issueNumber.toString(),
        includeFilteredRules: includeFilteredItems,
      },
      (data) => this.mapper.mapGQLModel(data)
    );
  }
}
